'use client';

export default function CenteredLayout(props: { children: React.ReactNode }) {
  return (
    <section className="flex h-screen flex-col">
      <div className="flex items-center justify-center">{props.children}</div>
    </section>
  );
}
